// utils/device.js

const deviceDetect = {
    isMobile() {
        const userAgent = navigator.userAgent.toLowerCase();
        const mobileKeywords = ['iphone', 'ipod', 'ipad', 'android', 'mobile', 'blackberry', 'webos', 'windows phone'];
        const isMobileDevice = mobileKeywords.some(keyword => userAgent.includes(keyword));
        const isMobileWidth = window.innerWidth <= 768;

        return isMobileDevice || isMobileWidth;
    },

    getPlatform() {
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod')) {
            return 'ios';
        }
        if (userAgent.includes('android')) {
            return 'android';
        }
        return 'desktop';
    },

    isTablet() {
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.includes('ipad') ||
            (userAgent.includes('android') && !userAgent.includes('mobile'));
    }
};

export default deviceDetect;



// // utils/device.js
//
// export const deviceDetect = {
//     // 检测是否是移动设备
//     isMobile() {
//         const userAgent = navigator.userAgent.toLowerCase();
//         const mobileKeywords = ['iphone', 'ipod', 'ipad', 'android', 'mobile', 'blackberry', 'webos', 'windows phone'];
//
//         // 检查是否包含移动设备关键词
//         const isMobileDevice = mobileKeywords.some(keyword => userAgent.includes(keyword));
//
//         // 同时检查屏幕宽度
//         const isMobileWidth = window.innerWidth <= 768;
//
//         return isMobileDevice || isMobileWidth;
//     },
//
//     // 检测具体的移动平台
//     getPlatform() {
//         const userAgent = navigator.userAgent.toLowerCase();
//
//         if (userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod')) {
//             return 'ios';
//         } else if (userAgent.includes('android')) {
//             return 'android';
//         }
//
//         return 'desktop';
//     },
//
//     // 检测是否是平板设备
//     isTablet() {
//         const userAgent = navigator.userAgent.toLowerCase();
//         return (
//             userAgent.includes('ipad') ||
//             (userAgent.includes('android') && !userAgent.includes('mobile'))
//         );
//     }
// };
//
// export default deviceDetect;